import React, { useEffect, useState } from "react"
import { useTranslation } from "react-i18next"
import { useMediaQuery } from "react-responsive"
import { useRecoilState } from "recoil"
import { ShowHeader } from "../../states/showHeader"
import { ShowToast } from "../../states/showToast"
import { Box, Container, Typography, Grid, Image, Button } from "src/UILibrary"
import { Title } from "src/components/layout/Title"
import { NewsDetailItem } from "./components/NewsDetailItem"
import { useNavigate, useParams } from "react-router-dom"
import { News, NewsService } from "src/openapi"
import "src/styles/common.scss"
import {
  NEWS_INTERVIEW_TYPES_STRING,
  RESPONSE_CODE,
  SNACKBAR_TYPES,
  SORT_ORDER,
} from "src/modules/const"

export const NewsDetailPage = () => {
  const { t } = useTranslation("translation", { keyPrefix: "news" })

  const [, setShowHeader] = useRecoilState(ShowHeader)
  const [, setShowToast] = useRecoilState(ShowToast)

  const [news, setNews] = useState<News>()
  const [recent, setRecent] = useState<News[]>([])
  const isTablet = useMediaQuery({ query: "(min-width: 900px)" })
  const params = useParams()
  const navigate = useNavigate()

  useEffect(() => {
    setShowHeader(true)
    handleGetNews()
    handleGetRecentNews()
  }, [params])

  const extractDate = (date?: string) => {
    let ret
    if (!date) return ""
    ret = date.replaceAll("-", "/")
    return ret.substring(0, 10)
  }

  const handleGetNews = () => {
    NewsService.newsDetail(parseInt(params.id!), undefined)
      .then((res) => {
        if (res.status === RESPONSE_CODE.SUCCESS) {
          setNews(res.data as News)
        } else {
          setShowToast({ show: true, text: t("failed"), type: SNACKBAR_TYPES.ERROR })
        }
      })
      .catch(() => {
        setShowToast({ show: true, text: t("failed"), type: SNACKBAR_TYPES.ERROR })
      })
  }

  const handleGetRecentNews = () => {
    NewsService.newsList(
      undefined,
      0,
      3,
      undefined,
      undefined,
      undefined,
      SORT_ORDER.DESCENDONG,
      "created_at"
    )
      .then((res) => {
        if (res.status === RESPONSE_CODE.SUCCESS) {
          setRecent([...(res.data?.news as News[])])
        }
      })
      .catch(() => {})
  }

  return (
    <>
      <Title title={t("news_title")} sub_title={t("news_detail_sub_title")} />
      <Container maxWidth="md" sx={{ px: "10px", py: "20px", mb: "0px" }}>
        <Box textAlign={"center"}>
          <Image
            src={news?.imageUrl!}
            // sx={{ height: 225, flex: 1, resizeMode: "cover", bgcolor: "transparent" }}
            sx={{ flex: 1, resizeMode: "cover", bgcolor: "transparent" }}
          />
        </Box>
        <Box sx={{ p: "20px 0px 40px 0px", borderBottom: "1px solid grey" }}>
          <Box display="flex" sx={{ mb: "20px" }} alignItems="center">
            <Typography.Action
              color="textPrimary"
              className="notosans weight500"
              sx={{
                borderRadius: isTablet ? 0 : 0,
                border: "1px solid",
                borderColor: "text.primary",
                lineHeight: "20px",
                px: "0.625rem",
                mr: "auto",
              }}
              fontSize={14}
            >
              {news?.type == NEWS_INTERVIEW_TYPES_STRING.NEWS ? t("news") : t("interview")}
            </Typography.Action>
            <Typography.Description className="notosans weight500 grey" lineHeight={1.25} mr={1.25}>
              {extractDate(news?.createdAt)}
            </Typography.Description>
          </Box>
          <Typography.SubTitle
            color="textPrimary"
            lineHeight={isTablet ? "42px" : "30px"}
            fontWeight={500}
            fontSize={isTablet ? 28 : 20}
          >
            {news?.title}
          </Typography.SubTitle>
        </Box>
      </Container>
      <Container maxWidth="md" sx={{ px: "10px", py: "20px", mb: "0px" }}>
        <Box sx={{ mb: "20px" }} alignItems="center">
          <Box sx={{ overflow: "hidden" }} dangerouslySetInnerHTML={{ __html: news?.content! }} />
          {/* <Box>{news?.content}</Box> */}
          <Box textAlign="center" sx={{ mt: "40px", mb: "60px" }}>
            <Button
              variant="outlined"
              className="notosans weight500"
              sx={{
                p: "10px",
                width: 240,
                fontSize: 16,
                borderRadius: 0,
              }}
              color="secondary"
              onClick={() => {
                navigate("/news")
              }}
            >
              {t("back_to_news_list")}
            </Button>
          </Box>
        </Box>
      </Container>
      <Box
        sx={{
          pb: "80px",
        }}
        bgcolor="background.body"
        component="form"
        autoComplete="off"
        className="main-body-with-footer "
      >
        <Container maxWidth="lg" sx={{ px: "0px", py: "0px" }}>
          <Typography.Large color="textPrimary" sx={{ ml: "20px", mt: "0px", pt: "60px" }}>
            {t("additional_info")}
          </Typography.Large>
          <Grid container minHeight={300} sx={{ px: "10px", pt: "0px", pb: "20px" }}>
            {recent.map((n, index) => (
              <Grid item md={4} sm={12} xs={12} key={index}>
                <Box sx={{ p: "10px 0px" }}>
                  <NewsDetailItem item={n!} />
                </Box>
              </Grid>
            ))}
          </Grid>
        </Container>
      </Box>
    </>
  )
}
